import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import * as fromStore from '../../_store';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import { COUNTRY_CODE_ITALY, COUNTRY_CODE_PORTUGAL, SESSION_VAR_KEY_MARKET } from '@ibe.config';
import { insuranceAddressbyCountryValidator, insuranceCitybyCountryValidator, insuranceNIFbyCountryValidator, insurancePostalCodebyCountryValidator } from '@ibe.components/shared/sidebar-views/passengers-new/passengers-new.utils';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRAPassengerDetailChubbComponent = /** @class */ (function () {
    function INDRAPassengerDetailChubbComponent(fb, store, globalStore, ibeAdminService) {
        this.fb = fb;
        this.store = store;
        this.globalStore = globalStore;
        this.ibeAdminService = ibeAdminService;
        this.displayValidationMessages = false;
        this.insuranceFormShow = null;
        this.form = this.fb.group({
            vatNumber: [null, [Validators.required]],
            address: [null, [Validators.required, Validators.pattern('[a-zA-Z0-9_ ]+')]],
            zipcode: [null, [Validators.required, Validators.pattern('[a-zA-Z0-9_-]+')]],
            city: [null, [Validators.required]],
        });
        this.isITMarket = false;
        this.isPTMarket = false;
        this.sub$ = new Subscription();
        this._hasChanges = new BehaviorSubject(false);
        var market = sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
        if (market == COUNTRY_CODE_ITALY) {
            this.isITMarket = true;
            this.form = this.fb.group({
                vatNumber: [null, [Validators.required, insuranceNIFbyCountryValidator(market)]],
            });
        }
        else if (market === COUNTRY_CODE_PORTUGAL) {
            this.isPTMarket = true;
            this.form = this.fb.group({
                vatNumber: [null, [Validators.required, insuranceNIFbyCountryValidator(market)]],
                address: [null, [Validators.required, insuranceAddressbyCountryValidator(market)]],
                zipcode: [null, [Validators.required, insurancePostalCodebyCountryValidator(market)]],
                city: [null, [Validators.required, insuranceCitybyCountryValidator(market)]],
            });
        }
    }
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasErrorClassVatNumber", {
        get: function () {
            return this.form.get('vatNumber').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasErrorClassAddress", {
        get: function () {
            return this.form.get('address').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasErrorClassZipCode", {
        get: function () {
            return this.form.get('zipcode').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasErrorClassCity", {
        get: function () {
            return this.form.get('city').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailChubbComponent.prototype, "hasErrors", {
        get: function () {
            return !_.isEmpty(this.form.errors);
        },
        enumerable: true,
        configurable: true
    });
    INDRAPassengerDetailChubbComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub$.add(this.store.select(fromStore.getSelectedPassengersAtIndex)
            .subscribe(function (passenger) {
            if (passenger) {
                _this.mapPassengerToForm(passenger);
            }
        }));
        this.sub$.add(this.form.valueChanges.subscribe(function () { return _this._hasChanges.next(true); }));
        this.formValueChangesUpdateTravelInsurance();
    };
    INDRAPassengerDetailChubbComponent.prototype.formValueChangesUpdateTravelInsurance = function () {
        var _this = this;
        this.sub$.add(this.form.get('vatNumber').valueChanges.subscribe(function () { return _this.dispatchUpdateTravelInsurance(); }));
        if (!this.isITMarket) {
            this.sub$.add(this.form.get('address').valueChanges.subscribe(function () { return _this.dispatchUpdateTravelInsurance(); }));
            this.sub$.add(this.form.get('zipcode').valueChanges.subscribe(function () { return _this.dispatchUpdateTravelInsurance(); }));
            this.sub$.add(this.form.get('city').valueChanges.subscribe(function () { return _this.dispatchUpdateTravelInsurance(); }));
        }
        this.dispatchUpdateTravelInsurance();
    };
    INDRAPassengerDetailChubbComponent.prototype.dispatchUpdateTravelInsurance = function () {
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateTravelInsurance': true }));
    };
    INDRAPassengerDetailChubbComponent.prototype.mapPassengerToForm = function (data) {
        this.form.patchValue({
            vatNumber: data.travelInsurance ? data.travelInsurance.vatNumber : '',
            address: data.travelInsurance ? data.travelInsurance.address : '',
            zipcode: data.travelInsurance ? data.travelInsurance.zipcode : '',
            city: data.travelInsurance ? data.travelInsurance.city : ''
        }, { emitEvent: false });
    };
    INDRAPassengerDetailChubbComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    INDRAPassengerDetailChubbComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    INDRAPassengerDetailChubbComponent.prototype.formTravelInsuranceErrors = function (control) {
        var errors = [];
        switch (control) {
            case 'address':
                if (this.form.controls['address'].hasError('emptyValue') || this.form.controls['address'].hasError('required')) {
                    errors.push('bookingDetails.error.addressRequired');
                }
                else {
                    if (this.isPTMarket) {
                        errors.push('bookingDetails.error.addressInvalidFiveLetters');
                    }
                    else {
                        errors.push('bookingDetails.error.addressInvalid');
                    }
                }
                break;
            case 'zipcode':
                if (this.form.controls['zipcode'].hasError('emptyValue') || this.form.controls['zipcode'].hasError('required')) {
                    errors.push('bookingDetails.error.zipcodeRequired');
                }
                else {
                    errors.push('bookingDetails.error.zipcodeInvalid');
                }
                break;
            case 'city':
                if (this.form.controls['city'].hasError('emptyValue') || this.form.controls['city'].hasError('required')) {
                    errors.push('bookingDetails.error.cityRequired');
                }
                else {
                    if (this.isPTMarket) {
                        errors.push('bookingDetails.error.cityInvalidTwoLettersNoDigits');
                    }
                }
                break;
            default:
                if (this.form.controls['vatNumber'].hasError('emptyValue') || this.form.controls['vatNumber'].hasError('required')) {
                    errors.push('bookingDetails.error.vatNumberRequired');
                }
                else {
                    errors.push(this.ibeAdminService.getTranslationValue('bookingDetails.error.vatNumberInvalid'));
                    if (this.isPTMarket) {
                        errors.push(this.ibeAdminService.getTranslationValue('bookingDetails.error.useNineDigits'));
                    }
                    else if (this.isITMarket) {
                        errors.push(this.ibeAdminService.getTranslationValue('bookingDetails.error.useVatNumberItalianFormat'));
                    }
                }
                break;
        }
        return errors.join(' ');
    };
    INDRAPassengerDetailChubbComponent.prototype.clearForm = function () {
        this.form.reset({ emitEvent: false });
    };
    INDRAPassengerDetailChubbComponent.prototype.cancelEdit = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedPassengersAtIndex)
            .pipe(take(1)).subscribe(function (data) {
            _this.form.reset({
                vatNumber: data.travelInsurance ? data.travelInsurance.vatNumber : '',
                address: data.travelInsurance ? data.travelInsurance.address : '',
                zipcode: data.travelInsurance ? data.travelInsurance.zipcode : '',
                city: data.travelInsurance ? data.travelInsurance.city : ''
            }, { emitEvent: false });
            _this._hasChanges.next(false);
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({
            'updateTravelInsurance': false,
        }));
    };
    return INDRAPassengerDetailChubbComponent;
}());
export { INDRAPassengerDetailChubbComponent };
